import { render } from "./StatusBar.vue?vue&type=template&id=4d0fa35b"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"

import "./StatusBar.vue?vue&type=style&index=0&id=4d0fa35b&lang=scss"

import exportComponent from "B:\\www\\aviahomes\\wp-content\\plugins\\avia-colour-selector\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__